<template>
  <div :data-e2e="TableCypressAttribute.buttons.EDIT">
    <ActionIcon
      :action-fn="_editFn"
      icon="pencil"
      :cell-data="cellData"
      :tooltip-position="tooltipPosition"
      :tooltip="formattedTooltip"
      :is-multilined-tooltip="isMultilinedTooltip"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { ActionCellMixin } from '/@/modules/core/table/mixins/ActionCellMixin';
import ActionIcon from '/@/modules/core/app/components/ActionIcon.vue';
import { TableCypressAttribute } from '/@/modules/core/table/constants/TableCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ActionCellEdit',
  mixins: [ActionCellMixin],
  components: { ActionIcon },
  props: {
    editFn: {
      type: Function,
      required: false
    },
    tooltip: { type: String },
    tooltipPosition: { type: String },
    disabled: { type: Boolean, default: false },
    isMultilinedTooltip: { type: Boolean }
  },
  static: {
    TableCypressAttribute
  },
  computed: {
    formattedTooltip() {
      return this.tooltip ?? this.$t('asset.edit');
    }
  },
  methods: {
    _editFn(...args) {
      this.editFn(...args);
    }
  }
};
</script>
